<template>
  <div class="content-view">
    <h1>Tutaj będzie Pulpit Użytkownika</h1>
  </div>
</template>

<script>
export default {
  name: "User"
}
</script>

<style scoped>

</style>
